/* eslint-disable array-callback-return */
import { keyBy } from 'lodash';

export const remapClients = (clients) => {
  return keyBy(clients, 'clientRecordId');
};

export const remapUsers = (users) => {
  return keyBy(users, 'id');
};

export const extractManagers = (clients) => {
  let managers = [];
  clients.map((client) => {
    if (!managers.some((manager) => manager === client.serviceRep) && client.serviceRep != null && client.serviceRep.length !== 0) {
      managers.push(client.serviceRep);
    }
  });
  return managers.sort((a, b) => a > b ? 1 : -1);
};

export const sortById = (clients) => clients.sort((a, b) => a.moveTrackClientId - b.moveTrackClientId);

export const cleanClientDetails = (clientDetails) => {
  clientDetails.addedOn = clientDetails.addedOn?.split('T')[0];
  clientDetails.modifiedOn = clientDetails.modifiedOn?.split('T')[0];
  clientDetails.contractDate = clientDetails.contractDate?.split('T')[0];
  clientDetails.contractExpires = clientDetails.contractExpires?.split('T')[0];
  clientDetails.renewalStart = clientDetails.renewalStart?.split('T')[0];
  clientDetails.renewalEnd = clientDetails.renewalEnd?.split('T')[0];
  clientDetails.cancelDate = clientDetails.cancelDate?.split('T')[0];
  return clientDetails;
};

export const getMonth = (num) => {
  if (num === 0) return 'Jan';
  else if (num === 1) return 'Feb';
  else if (num === 2) return 'Mar';
  else if (num === 3) return 'Apr';
  else if (num === 4) return 'May';
  else if (num === 5) return 'Jun';
  else if (num === 6) return 'Jul';
  else if (num === 7) return 'Aug';
  else if (num === 8) return 'Sep';
  else if (num === 9) return 'Oct';
  else if (num === 10) return 'Nov';
  else if (num === 11) return 'Dec';
};

export const isValidString = (value) => {
    if (value == null) {
        return false;
    }

    if (typeof value === 'string') {
        return value.trim() !== '';
    }

    return true;
}

/**
 * Helper function to find country ID from country code or long name
 * @param {string} countryCode - The country short code (e.g., 'US', 'CA')
 * @param {string} countryLongName - The full country name (e.g., 'United States')
 * @param {Array} countriesEnum - Array of country objects with id, shortName, title, longName
 * @returns {string} - The country ID or empty string if not found
 */
export const findCountryId = (countryCode, countryLongName, countriesEnum) => {
  if (!countriesEnum || (!countryCode && !countryLongName)) return '';
  
  // Try exact short name match first
  let country = countriesEnum.find((c) => c.shortName === countryCode);
  
  // Try title match with short name
  if (!country) {
    country = countriesEnum.find((c) => c.title === countryCode);
  }
  
  // Try long name match
  if (!country && countryLongName) {
    country = countriesEnum.find((c) => c.title === countryLongName || c.longName === countryLongName);
  }
  
  // Try case-insensitive partial match
  if (!country && countryLongName) {
    const lowerLongName = countryLongName.toLowerCase();
    country = countriesEnum.find((c) => 
      c.title?.toLowerCase() === lowerLongName || 
      c.longName?.toLowerCase() === lowerLongName
    );
  }
  
  return country ? country.id : '';
};

/**
 * Helper function to find province/state ID from state code or long name
 * @param {string} stateCode - The state/province short code (e.g., 'CA', 'NY')
 * @param {string} stateLongName - The full state/province name (e.g., 'California')
 * @param {Array} provincesEnum - Array of province/state objects with id, shortName, title, longName
 * @returns {string} - The province/state ID or empty string if not found
 */
export const findProvinceId = (stateCode, stateLongName, provincesEnum) => {
  if (!provincesEnum || (!stateCode && !stateLongName)) return '';
  
  // Try exact short name match first
  let province = provincesEnum.find((p) => p.shortName === stateCode);
  
  // Try title match with short name
  if (!province) {
    province = provincesEnum.find((p) => p.title === stateCode);
  }
  
  // Try long name match
  if (!province && stateLongName) {
    province = provincesEnum.find((p) => p.title === stateLongName || p.longName === stateLongName);
  }
  
  // Try case-insensitive partial match
  if (!province && stateLongName) {
    const lowerLongName = stateLongName.toLowerCase();
    province = provincesEnum.find((p) => 
      p.title?.toLowerCase() === lowerLongName || 
      p.longName?.toLowerCase() === lowerLongName
    );
  }
  
  return province ? province.id : '';
};

export const sortByTitle = (options) => [...options].sort((a, b) => (a.title || '').localeCompare(b.title || ''));

// Matches [EnumerationV2].[Country] seed data in the ReloInsight V2 API.
export const USA_COUNTRY_ID = 'd94a0819-59a2-443f-bc99-1ee360057f38';

export const sortCountries = (countries) => {
  const isUsa = (c) => c.id?.toLowerCase() === USA_COUNTRY_ID;
  return [...countries.filter(isUsa), ...sortByTitle(countries.filter((c) => !isUsa(c)))];
};

// Columns with `parentField` only show options whose `parentOptionKey` matches the parent's selected value.
export const getDependentOptions = (column, values) =>
  column.parentField ? column.options.filter((opt) => opt[column.parentOptionKey] === values[column.parentField]) : column.options;

export const setValueAndClearDependents = (columns, values, name, value) => {
  const next = { ...values, [name]: value };
  columns.forEach((col) => {
    if (col.parentField === name) next[col.accessorKey] = '';
  });
  return next;
};
